/**
 * Whether the facility holds EHR diet changes for review at all: EHR on and
 * diet order locking on (where WinForms shows pending diets). The Dashboard
 * draws the Held EHR diet changes card only then.
 *
 * Jeff decided on 2026-10-22 that a card explaining a feature is off is
 * clutter, so the card no longer appears (with a reason) everywhere else.
 */
export function heldChangesApply({
  facilityEhrActive,
  dietOrderLockingActive,
}: {
  facilityEhrActive: boolean;
  dietOrderLockingActive: boolean;
}): boolean {
  return facilityEhrActive && dietOrderLockingActive;
}

/**
 * Why the Held EHR diet changes card can't show anything for this facility
 * and user, or `null` when it can.
 *
 * Order matters: a facility with no EHR has nothing to hold regardless of
 * the user's rights, so that reason wins. The rights check comes last and
 * only ever produces a message - the held rows are not requested at all.
 * Since 2026-10-22 the Dashboard shows the card only where heldChangesApply
 * is true, so of these only the rights message reaches the screen there.
 */
export function heldChangesUnavailableReason({
  ehrTitle,
  facilityEhrActive,
  dietOrderLockingActive,
  canViewDietFluctuations,
}: {
  ehrTitle: string;
  facilityEhrActive: boolean;
  dietOrderLockingActive: boolean;
  canViewDietFluctuations: boolean;
}): string | null {
  if (!facilityEhrActive) return 'EMR Integration is not enabled for this facility.';
  if (!dietOrderLockingActive) {
    return `Diet order locking is off for this facility, so ${ehrTitle} diet changes are not held for review.`;
  }
  if (!canViewDietFluctuations) return 'Your role does not include viewing diet changes.';
  return null;
}
